// frontend/apps/widgets/src/WidgetRouter.js
import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import TableReservationView from './widgets/TableReservation/view/TableReservationView';
import GiftVoucherView from './widgets/GiftVoucher/view/GiftVoucherView';
import WidgetPage from './widgets/common/WidgetPage';

export default function WidgetRouter() {
  return (
    <BrowserRouter>
      <WidgetPage>
        <Routes>
          <Route path="/reservations" element={<TableReservationView mode="fixed" />} />
          <Route path="/giftvouchers" element={<GiftVoucherView mode="fixed" />} />
          {/* Add other widgets here in the future */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </WidgetPage>
    </BrowserRouter>
  );
}
